<bl-select-modal-base
  [title]="'MODALS.SELECT_POST_SCOPE.TITLE' | translate"
  (closeClick)="closeModalWithoutSaving()"
  (search)="searchFilter.next($event)"
  class="ion-page"
>
  <ion-list lines="none">
    <ion-list-header>
      <span class="color--medium text--sm text--medium">
        {{ "MODALS.SELECT_POST_SCOPE.HEADER.ALL" | translate }}
      </span>
    </ion-list-header>

    <!-- all option -->
    <ion-item (click)="selectAll()">
      <ion-thumbnail slot="start">
        <svg-icon
          fontSize="42px"
          [key]="'all-scope'"
        ></svg-icon>
      </ion-thumbnail>
      <ion-label class="font--base">
        {{ "COMMON.POST_SCOPE.ALL" | translate }}
      </ion-label>
      <svg-icon
        *ngIf="publishGlobally"
        key="check"
        class="font--xxl"
      ></svg-icon>
    </ion-item>

    <!-- settlements -->
    <ion-list-header *ngIf="settlements.length > 0">
      <span class="color--medium text--sm text--medium">
        {{ "MODALS.SELECT_POST_SCOPE.HEADER.SETTLEMENTS" | translate }}
      </span>
    </ion-list-header>

    <ion-item
      *ngFor="let settlement of settlements"
      (click)="toggleSettlement(settlement)"
    >
      <ng-container *ngIf="settlement.picture_url; else settlementIcon">
        <ion-thumbnail slot="start">
          <img
            [src]="settlement.picture_url"
            alt=""
            aria-hidden="true"
          />
        </ion-thumbnail>
      </ng-container>
      <ng-template #settlementIcon>
        <ion-thumbnail slot="start">
          <svg-icon
            fontSize="42px"
            [key]="'all-scope'"
          ></svg-icon>
        </ion-thumbnail>
      </ng-template>
      <ion-label class="font--base">{{ settlement.title }}</ion-label>
      <svg-icon
        *ngIf="settlement.selected"
        key="check"
        class="font--xxl"
      ></svg-icon>
    </ion-item>

    <!-- groups -->
    <ion-list-header *ngIf="groups.length > 0">
      <span class="color--medium text--sm text--medium">
        {{ "MODALS.SELECT_POST_SCOPE.HEADER.GROUPS" | translate }}
      </span>
    </ion-list-header>
    <ion-item
      *ngFor="let group of groups"
      (click)="toggleGroup(group)"
    >
      <ng-container *ngIf="group.picture_url; else groupIcon">
        <ion-thumbnail slot="start">
          <img
            [src]="group.picture_url"
            alt=""
            aria-hidden="true"
          />
        </ion-thumbnail>
      </ng-container>
      <ng-template #groupIcon>
        <ion-thumbnail slot="start">
          <svg-icon
            fontSize="42px"
            [key]="'all-scope'"
          ></svg-icon>
        </ion-thumbnail>
      </ng-template>
      <ion-label class="font--base">{{ group.title }}</ion-label>
      <svg-icon
        *ngIf="group.selected"
        key="check"
        class="font--xxl"
      ></svg-icon>
    </ion-item>
  </ion-list>
</bl-select-modal-base>
<ion-footer class="ion-no-border ion-padding-horizontal">
  <ion-toolbar class="py-5">
    <ion-button
      (click)="closeModal()"
      expand="block"
    >
      {{ "COMMON.LABELS.APPLY" | translate }}
    </ion-button>
  </ion-toolbar>
</ion-footer>
